import { Dayjs } from 'dayjs';

import { isOwnMessage, MessagingMessage } from '~hooks/useMessaging/models';
import { Nullable } from '~types/Nullable';

const RUN_WINDOW_IN_MINUTES = 5;

type TranscriptMessageItem = {
  endsRun: boolean;
  isOwn: boolean;
  kind: 'message';
  key: string;
  message: MessagingMessage;
  showSender: boolean;
  startsRun: boolean;
};

type TranscriptItem =
  | { day: Dayjs; kind: 'day-separator'; key: string }
  | { kind: 'unread-divider'; key: string }
  | TranscriptMessageItem;

const UNREAD_DIVIDER_KEY = 'unread-divider';

export const transcriptItems = (
  messages: MessagingMessage[],
  viewerUserId: Nullable<string>,
  unreadDividerMessageId: Nullable<string> = null,
): TranscriptItem[] => {
  const items: TranscriptItem[] = [];
  let previousMessageItem: Nullable<TranscriptMessageItem> = null;

  for (const message of messages) {
    const previousCreatedAt = previousMessageItem?.message.createdAt;
    const previousSenderKey = previousMessageItem?.message.senderKey;
    const startsNewDay =
      !previousCreatedAt || !message.createdAt.isSame(previousCreatedAt, 'day');

    if (startsNewDay) {
      items.push({
        day: message.createdAt,
        kind: 'day-separator',
        key: `day-${message.createdAt.format('YYYY-MM-DD')}`,
      });
    }

    const startsUnread = message.id === unreadDividerMessageId;

    if (startsUnread) {
      items.push({ kind: 'unread-divider', key: UNREAD_DIVIDER_KEY });
    }

    const isOwn = isOwnMessage(message, viewerUserId);
    const startsRun =
      startsNewDay ||
      startsUnread ||
      message.senderKey !== previousSenderKey ||
      message.createdAt.diff(previousCreatedAt, 'minute', true) > RUN_WINDOW_IN_MINUTES;

    if (startsRun && previousMessageItem) {
      previousMessageItem.endsRun = true;
    }

    const messageItem: TranscriptMessageItem = {
      endsRun: false,
      isOwn,
      kind: 'message',
      key: message.id,
      message,
      showSender: !isOwn && startsRun,
      startsRun,
    };

    items.push(messageItem);

    previousMessageItem = messageItem;
  }

  if (previousMessageItem) {
    previousMessageItem.endsRun = true;
  }

  return items;
};
